// src/components/lists/AccountsList/accountTypes.ts

export type LedgerItem = {
  id: number;
  date: string;
  type: string;
  description: string;
  transactionReference?: string;
  ref: string;
  debit: number;
  credit: number;
  balance: number;
};

export type InvoiceItem = {
  id: number;
  invoiceNo: string;
  date: string;
  booking: string;
  total: number;
  paid: number;
  outstanding: number;
  status: string;
};

export const statusColor = (
  status: string
): 'success' | 'warning' | 'error' | 'default' => {
  switch (status) {
    case 'Paid':
      return 'success';
    case 'Pending':
      return 'warning';
    case 'Overdue':
      return 'error';
    default:
      return 'default';
  }
};

export const typeColor = (
  type: string
): 'success' | 'error' | 'info' | 'warning' | 'default' => {
  switch (type) {
    case 'Payment':
    case 'Deposit':
      return 'success';
    case 'Invoice':
      return 'warning';
    case 'Refund':
    case 'Credit':
    case 'Cancellation':
      return 'info';
    default:
      return 'default';
  }
};

const currencyFormatter = new Intl.NumberFormat('en', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true,
});

export const formatCurrency = (amount: number): string =>
  amount === 0 ? '' : `R ${currencyFormatter.format(amount)}`;
